module.exports = __webpack_public_path__ + "static/media/remove.4a453b43.svg";